// extracted by mini-css-extract-plugin
export default {"section":"ContractsFilterSection_section__Zl5A2","field":"ContractsFilterSection_field__5cbUS"};